import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import TopBanner from "@/components/TopBanner";
import { useSEO } from "@/hooks/useSEO";

const PortfolioStrip = lazy(() => import("@/components/PortfolioStrip"));
const ServicesSection = lazy(() => import("@/components/ServicesSection"));
const PricingSection = lazy(() => import("@/components/PricingSection"));
const WhyUsSection = lazy(() => import("@/components/WhyUsSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const KnowledgeBase = lazy(() => import("@/components/KnowledgeBase"));
const Footer = lazy(() => import("@/components/Footer"));
const ChatWidget = lazy(() => import("@/components/ChatWidget"));

const Index = () => {
  useSEO({
    title: "Strony internetowe Kalisz — BestSite | Strony WWW, SEO i widoczność w AI",
    description: "Tworzenie stron internetowych w Kaliszu i Wielkopolsce. Pozycjonowanie SEO i widoczność w AI (ChatGPT, Gemini, Google AI). Sklepy bez abonamentu. Darmowa wycena w 24h.",
    canonical: "/",
    keywords: "strony internetowe Kalisz, tworzenie stron www Kalisz, projektowanie stron Wielkopolska, pozycjonowanie SEO Kalisz, widoczność w AI, optymalizacja pod AI, GEO, AEO, sklep internetowy Kalisz",
  });

  return (
    <div className="min-h-screen bg-background">
      <TopBanner />
      <Navbar />
      <main>
        <HeroSection />
        <Suspense fallback={null}>
          <PortfolioStrip />
          <ServicesSection />
          <PricingSection />
          <WhyUsSection />
          <FAQSection />
          <KnowledgeBase />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
        <ChatWidget />
      </Suspense>
    </div>
  );
};

export default Index;
